<form [formGroup]="searchForm">
  <mat-icon class="search-icon" inline="true">search</mat-icon>

  <div class="site-shortcut-icon">/</div>

  <input
    #searchBox
    placeholder="Quick search..."
    formControlName="autoCompleteSearch"
    (keydown.escape)="searchBox.blur()"
    (keydown.enter)="searchBox.blur()"
    [matAutocomplete]="siteSearch"
    />

  <mat-autocomplete
    class="autocomplete-search"
    #siteSearch="matAutocomplete"
    autoActiveFirstOption
    (optionSelected)="navigateToPage($event)"
    >
    @for (menuGroup of siteMenuFiltered$ | async; track menuGroup) {
      <mat-optgroup [label]="menuGroup.groupName">
        @for (link of menuGroup.links; track link) {
          <mat-option [value]="link.url">
            {{ link.name }}
            @if (link.selector) {
              <span class="autocomplete-list-selector">
                {{ link.selector }}
              </span>
            }
          </mat-option>
        }
      </mat-optgroup>
    }

    <mat-optgroup label="Observatory Pages">
      <mat-option value="/">Home</mat-option>
    </mat-optgroup>
  </mat-autocomplete>
</form>
